/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { USER_LOGOUT_ACTION } from 'constants/user'
import {
  getUserDetails,
  getShippingHistory,
  getPaymentHistory,
} from 'api/client/actions/user'
import { handlePromiseActions, createModuleAction } from 'redux-app/utils/reducer'
import { loadingWrapper } from 'redux-app/utils/loadingWrapper'

const createAction = createModuleAction('user')

export const acceptCookie = createAction('ACCEPT_COOKIE')
export const onShowNewPlanAcceptedMessage = createAction('SHOW_NEW_PLAN_MESSAGE')
export const onHideNewPlanAcceptedMessage = createAction('HIDE_NEW_PLAN_MESSAGE')

const ACTION_HANDLERS = {
  [getUserDetails.toString()]: loadingWrapper('userDetails', [
    null,
    (state, { payload: { result } }) => result,
    null,
  ]),
  [acceptCookie.toString()]: state => ({
    ...state,
    isCookieAccepted: true,
  }),
  [onShowNewPlanAcceptedMessage.toString()]: state => ({
    ...state,
    isPlanAcceptedMessageShown: true,
  }),
  [onHideNewPlanAcceptedMessage.toString()]: state => ({
    ...state,
    isPlanAcceptedMessageShown: false,
  }),
  [USER_LOGOUT_ACTION]: state => ({
    ...initialState,
    isCookieAccepted: state.isCookieAccepted,
  }),
  [getShippingHistory.toString()]: loadingWrapper('subscriptionHistory', [
    null,
    (state, { payload: { result } }) => result,
    null,
  ]),
  [getPaymentHistory.toString()]: loadingWrapper('paymentHistory', [
    null,
    (state, { payload: { result } }) => result,
    null,
  ]),
}

export const initialState = {
  userDetails: {},
  isCookieAccepted: false,
  subscriptionHistory: {
    value: [],
  },
  paymentHistory: {
    value: [],
  },
  isPlanAcceptedMessageShown: false,
}

export default handlePromiseActions(ACTION_HANDLERS, initialState)
